import React from 'react'
import PropTypes from 'prop-types'
import { CX } from '../../constants'
import Button from '../button'
import Block from '../block'
import Text from '../text'

class ModalLayout extends React.PureComponent {
  
  state = {
    countdown: -1,
    allowClose: true,
  }

  componentDidMount() {
    // When shouldDelay is true and canClose is false, start the countdown
    if (this.props.shouldDelay && !this.props.canClose) {
      this.setState({ allowClose: false, countdown: 5 })
      this.startCountdown()
    }
  }

  componentDidUpdate(prevProps) {
    // When shouldDelay is true and canClose is false, start the countdown
    if (this.props.shouldDelay && !this.props.canClose) {
      if (prevProps.shouldDelay !== this.props.shouldDelay || prevProps.canClose !== this.props.canClose) {
        this.setState({ allowClose: false, countdown: 5 })
        this.startCountdown()
      }
    } else if (this.props.canClose) {
      this.setState({ allowClose: true })
    }
  }

  startCountdown = () => {
    const timer = setInterval(() => {
      this.setState(prevState => ({
        countdown: prevState.countdown - 1
      }), () => {
        if (this.state.countdown <= 0) {
          clearInterval(timer)
          this.setState({ allowClose: true })
        }
      })
    }, 1000)
  }

  onHandleCloseModal = () => {
    if (this.state.allowClose) {
      this.props.onClose()
    }
  }

  render() {
    const {
      title,
      children,
      width,
      hideClose,
      noPadding,
      isXS,
    } = this.props
    const { countdown, allowClose } = this.state
    const childrenContainerClasses = CX({
      d: 1,
      maxH80VH: 1,
      overflowYScroll: 1,
      saveAreaInsetMB: isXS,
      px15: !noPadding,
      py10: !noPadding,
    })

    const innerClasses = CX({
      d: 1,
      boxShadowModal: 1,
      bgPrimary: 1,
      overflowHidden: 1,
      radiusSmall: !isXS,
      topLeftRadiusSmall: isXS,
      topRightRadiusSmall: isXS,
    })

    return (
      <div style={{width: `${width}px`}} className={[_s.d, _s.modal].join(' ')}>
        <div className={innerClasses}>
          {
            !!title && 
            <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.jcCenter, _s.borderBottom1PX, _s.borderColorSecondary, _s.h53PX, _s.px15].join(' ')}>
              <Text weight='bold' size='extraLarge'>
                {title}
              </Text>
              {
                !hideClose && !isXS && allowClose &&
                <Button
                  backgroundColor='tertiary'
                  title='Close'
                  className={[_s.h40PX, _s.w40PX, _s.aiCenter, _s.jcCenter, _s.mlAuto].join(' ')}
                  onClick={this.onHandleCloseModal}
                  color='secondary'
                  icon='close'
                  iconSize='12px'
                />
              }
              {
                !hideClose && !isXS && !allowClose &&
                <Button
                  backgroundColor='tertiary'
                  title='Wait...'
                  className={[_s.h40PX, _s.font, _s.fs16PX, _s.w40PX, _s.aiCenter, _s.jcCenter, _s.mlAuto].join(' ')}
                  color='primary'
                >
                  {countdown}s
                </Button>
              }
            </div>
          }
          {/*
            data-scrollable-parent tells the <ScrollableList> components
            underneath that this is the element to watch for scroll and touchmove
          */}
          <div className={childrenContainerClasses} data-scrollable-parent={true}>
            {children}
          </div>
        </div>
      </div>
    )
  }

}

ModalLayout.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  width: PropTypes.number,
  hideClose: PropTypes.bool,
  noPadding: PropTypes.bool,
  isXS: PropTypes.bool,
}

ModalLayout.defaultProps = {
  width: 600,
}

export default ModalLayout
